import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import { ChipStyled } from './style';
import { XIcon } from '..';

// Con `loading` la X se sustituye por un spinner y el chip no responde hasta que acaba la petición
const ChipCustom = ({ label, color, textColor, onDelete, targetId, fontSize, fontWeight, margin, loading = false }) => {
    const handleDelete = onDelete && !loading ? onDelete : undefined
    const deleteIcon = loading
        ? <CircularProgress size={12} thickness={5} color="inherit" className="chip-spinner" />
        : <XIcon />
    return (
        <ChipStyled targetId={targetId} onDelete={onDelete ? (handleDelete || (() => {})) : undefined} deleteIcon={deleteIcon} label={label} color={color} textColor={textColor} onClick={handleDelete} fontSize={fontSize} fontWeight={fontWeight} margin={margin} aria-busy={loading}/>
    )
}

ChipCustom.propType = {
    label: PropTypes.string,
    color: PropTypes.string,
    textColor: PropTypes.string,
    onDelete: PropTypes.func,
    targetId: PropTypes.number,
    loading: PropTypes.bool
}

export default ChipCustom;